module.exports = __webpack_public_path__ + "static/media/snazzy-basic1.0e4bac45.png";